import { Path, Rect, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4.75 4V20M19.25 20V4" vectorEffect="non-scaling-stroke" />
		<Rect x="7" y="10" width="10" height="4" fill="currentColor" stroke="none" />
	</SVG>
);
